export class UnsubscribeFromProductDto {
  public productId: string;
}
